// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".servers-configurator .ant-tabs-nav-wrap{padding-left:25%}@media (max-width:1199px){.servers-configurator .ant-tabs-nav-wrap{padding-left:0}}.servers-configurator .ant-tabs .ant-tabs-bottom-content>.ant-tabs-tabpane-inactive,.servers-configurator .ant-tabs .ant-tabs-top-content>.ant-tabs-tabpane-inactive{height:auto;max-height:0}.servers-configurator__iframe{padding-top:24px}", ""]);
// Exports
module.exports = exports;
